import { API_ENDPOINTS } from "@/config/app";

import { apiClient } from "../client";
import type { IUploadImage } from "./types";

export const commonApi = {
  async mediaUpload(media: File | Blob) {
    const formData = new FormData();
    formData.append("file", media);

    const response = await apiClient.postForm<IUploadImage>(
      `${API_ENDPOINTS.MEDIA}/upload`,
      formData
    );
    return response;
  },
};
